import {SEARCH_INPUT} from 'types/actions';

export const searchHomepage = element => ({
    type: SEARCH_INPUT,
    element
  });
